import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

if (!window.indexedDB) {
  const indexeddb =
    window.indexedDB ||
    window.mozIndexedDB ||
    window.webkitIndexedDB ||
    window.msIndexedDB;
  Object.defineProperty(window, "indexedDB", {
    value: indexeddb,
    configurable: true,
    enumerable: true,
    writable: true,
  });
}

if (!window.IDBTransaction) {
  const idbtransaction = window.IDBTransaction ||
    window.webkitIDBTransaction ||
    window.msIDBTransaction || { READ_WRITE: "readwrite" };
  Object.defineProperty(window, "IDBTransaction", {
    value: idbtransaction,
    configurable: true,
    enumerable: true,
    writable: true,
  });
}

if (!window.IDBKeyRange) {
  const idbkeyrange =
    window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange;
  Object.defineProperty(window, "IDBKeyRange", {
    value: idbkeyrange,
    configurable: true,
    enumerable: true,
    writable: true,
  });
}

if (!window.indexedDB) {
  console.log(
    "Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available."
  );
}

// Let us open our database
const request = window.indexedDB.open("JetFuel", 3);
request.onerror = function (event) {
  console.log("Why didn't you allow my web app to use IndexedDB?!");
};
request.onsuccess = function (event) {
  window.db = event.target.result;
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
};
request.onupgradeneeded = function (event) {
  const db = event.target.result;
  const upgradeTransaction = event.target.transaction;
  const stores = db.objectStoreNames;
  // Create an objectStore to hold information about our customers. We're
  // going to use "ssn" as our key path because it's guaranteed to be
  // unique - or at least that's what I was told during the kickoff meeting.
  if (!stores.contains("requests")) {
    db.createObjectStore("requests", { keyPath: "request_data" });
  }

  let saves;
  if (!stores.contains("saves")) {
    saves = db.createObjectStore("saves", { keyPath: "timestamp" });
  } else {
    saves = upgradeTransaction.objectStore("saves");
  }

  if (!saves.indexNames.contains("ident")) {
    saves.createIndex("ident", "ident", { unique: false });
  }
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
